import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Typography } from '@mui/material';
import { Fragment } from 'react';
import { renderStructuredContent } from '../../renderContext';
import { LeftNavDesktopTabs } from './LeftNavDesktopTabs';
import { LeftNavMobileAccordion } from './LeftNavMobileAccordion';
import type { LeftNavProps } from './types';
export const CreditCardsLeftNav = t0 => {
  const $ = _c(23);
  const {
    props
  } = t0;
  const {
    children,
    titledContent
  } = props;
  const nullCount = children.filter(_temp).length;
  if (nullCount > 0) {
    console.warn(`[CreditCardsLeftNav] ${nullCount}/${children.length} children are null — likely missing media items in this environment`);
  }
  let labels;
  let renderedContents;
  let t1;
  let t2;
  if ($[0] !== children || $[1] !== titledContent) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const validChildren = children.filter(Boolean);
      if (validChildren.length === 0) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <div id="brokenLeftNav" />;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        t2 = t3;
        break bb0;
      }
      labels = validChildren.map(_temp2);
      let t3;
      if ($[7] !== titledContent) {
        t3 = (child, index) => {
          const content = <Fragment key={`left-nav-content-${index}`}>{renderStructuredContent(child.props.children)}</Fragment>;
          if (titledContent) {
            return <><Typography sx={{
                mb: 2,
                pt: 3,
                fontSize: 18
              }} variant="textBold" component="h4">{child.props.label}</Typography>{content}</>;
          }
          return content;
        };
        $[7] = titledContent;
        $[8] = t3;
      } else {
        t3 = $[8];
      }
      renderedContents = validChildren.map(t3);
      t1 = validChildren.map(_temp3);
    }
    $[0] = children;
    $[1] = titledContent;
    $[2] = labels;
    $[3] = renderedContents;
    $[4] = t1;
    $[5] = t2;
  } else {
    labels = $[2];
    renderedContents = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const renderedImages = t1;
  let t3;
  if ($[9] !== labels || $[10] !== props.ordered || $[11] !== renderedContents) {
    t3 = <LeftNavMobileAccordion ordered={props.ordered} labels={labels} renderedContents={renderedContents} />;
    $[9] = labels;
    $[10] = props.ordered;
    $[11] = renderedContents;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== labels || $[14] !== props.ordered || $[15] !== props.showDivider || $[16] !== props.tabProps || $[17] !== renderedContents || $[18] !== renderedImages) {
    t4 = <LeftNavDesktopTabs ordered={props.ordered} showDivider={props.showDivider} tabProps={props.tabProps} labels={labels} renderedContents={renderedContents} renderedImages={renderedImages} />;
    $[13] = labels;
    $[14] = props.ordered;
    $[15] = props.showDivider;
    $[16] = props.tabProps;
    $[17] = renderedContents;
    $[18] = renderedImages;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t3 || $[21] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
};
function _temp(c) {
  return !c;
}
function _temp2(c_0) {
  return c_0.props.label;
}
function _temp3(child_0, index_0) {
  return child_0.props.imageUrl && child_0.props.imageAltText ? <CdnImage key={`left-nav-image-${index_0}`} loading="lazy" src={child_0.props.imageUrl} alt={child_0.props.imageAltText} height={200} width={200} style={{
    objectFit: "contain",
    padding: "10px",
    boxSizing: "content-box"
  }} /> : null;
}